import { VisuallyHidden } from '@ariakit/react';
import { asEntityId, IRoute } from '@websolutespa/bom-core';
import { useLayout, usePage } from '@websolutespa/bom-mixer-hooks';
import { useCallback } from 'react';
import { Button, Drawer, DrawerProps, Nav, NavLink, Text } from '../../components';

export type MarketsAndLanguagesDrawerProps = Partial<Omit<DrawerProps, | 'children'>>;

export const MarketsAndLanguagesDrawer: React.FC<MarketsAndLanguagesDrawerProps> = (props: MarketsAndLanguagesDrawerProps) => {
  const { markets, market: currentMarket, locales, locale: currentLocale } = useLayout();
  const { href, alternates } = usePage();

  const items = markets.map(market => ({
    ...market,
    locales: (market.languages && market.languages.length) ? locales.filter(l => market.languages ? market.languages.findIndex(language => asEntityId(language) === l.id) !== -1 : true) : locales,
  }));

  const getHref = useCallback((market: string, locale: string, currentMarket: string, currentLocale: string) => {
    const items = alternates || [];
    const alternateItem = items.find((x: IRoute) => x.market === market && x.locale === locale);
    if (alternateItem) {
      return alternateItem.id.toString();
    } else if (market === currentMarket && locale === currentLocale && href) {
      return href;
    } else {
      const segments: string[] = [];
      if (locales.length > 1) {
        segments.push(locale);
      }
      if (markets.length > 1) {
        segments.push(market);
      }
      return `/${segments.join('-')}`;
    }
  }, [alternates, href, markets.length, locales.length]);

  return (
    <Drawer name="markets-and-languages" placement="right" {...props}>
      <Drawer.Header>
        <Drawer.Title>
          <VisuallyHidden>
            Seleziona mercato e lingua
          </VisuallyHidden>
        </Drawer.Title>
      </Drawer.Header>
      <Drawer.Content flex="1" width="100vw" maxWidth="400px">
        {items && items.map(item => (
          <Nav.Col key={`${item.id}`} marginBottom="2rem" fontSize="0.9rem">
            <Text variant="paragraph10" fontWeight="700">{item.title}</Text>
            {item.locales && item.locales.map(locale => (
              <NavLink key={`${locale.id}`} href={getHref(item.id, locale.id, currentMarket, currentLocale)}>
                <Button as="a" lang={locale.id} role="menuitem" variant="nav" onClick={props.onClose}>{locale.title}</Button>
              </NavLink>
            ))}
          </Nav.Col>
        ))}
      </Drawer.Content>
    </Drawer>
  );
};
